<app-introduction></app-introduction>
<app-events></app-events>
<app-score-system></app-score-system>
<app-prizes></app-prizes>
